import SharedDialogBase from 'shared/components/dialog-base/dialog-base';
import { ButtonType } from 'core/enums/button-type';
import { ISharedDialogButton } from 'shared/components/dialog-base/dialog-base-interface';
import { useDialog } from 'core/providers/DialogProvider';

interface IConfirmationDialog {
  title: string;
  textContent: string;
  action: () => void;
  buttonLabel?: string;
  /**
   * What the way out is called.
   *
   * "Cancel" is the right word for most of these and the wrong one where the
   * action is itself a cancellation: two buttons reading Cancel and Cancel make
   * somebody stop and think about which is which, over a decision that should
   * be obvious.
   */
  dismissLabel?: string;
  loading?: boolean;
  testId?: string;
}

const ConfirmationDialog = ({
  title,
  textContent,
  action,
  buttonLabel = 'Confirm',
  dismissLabel = 'Cancel',
  loading = false,
  testId,
}: IConfirmationDialog) => {
  const dialog = useDialog();

  const customButtons: ISharedDialogButton[] = [
    {
      key: 'cancel',
      type: ButtonType.Button,
      buttonProps: {
        onClick: () => dialog?.closeDialog(),
        appearance: 'subtle',
        label: dismissLabel,
        type: 'button',
      },
    },
    {
      key: 'confirmAction',
      type: ButtonType.Button,
      buttonProps: {
        isLoading: loading,
        onClick: () => action(),
        appearance: 'danger',
        label: buttonLabel,
        type: 'button',
        ...(testId ? { testId } : {}),
      },
    },
  ];

  return <SharedDialogBase title={title} textContent={textContent} customButtons={customButtons} />;
};

export default ConfirmationDialog;
